<div class="monthly-total-account-table-wrapper">

  <ng-container *ngIf="!newFdTableView; else FdTableView">

    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 account-table" *ngIf="showTable">
      <ng-container [matColumnDef]="column.date" *ngFor="let column of displayedColumnObjects; let monthIndex=index;">

        <!-- Column Header -->
        <th mat-header-cell *matHeaderCellDef>
          <span *ngIf="monthIndex > 0">
            <div class="month">{{ months[column.month] }}</div>
            <div>{{ column.year }}</div>
          </span>
        </th>
        <!-- /Column Header -->

        <!-- TD Cell -->
        <td [ngClass]="{'attribute': monthIndex === 0, 'value': monthIndex > 0, 'last-row': last}"
          mat-cell *matCellDef="let element; let attributeIndex=index; last as last">

          <!-- Row Header -->
          <span *ngIf="monthIndex === 0" (click)="saveSummaryChanges()">
            {{ summaryDisplayAttributes[element[monthIndex].value] }}
          </span>
          <!-- /Row Header -->

          <!-- Cell View Only -->
          <ng-container *ngIf="isViewOnlyCell(monthIndex, attributeIndex)">

            <!-- Document Cell -->
            <span *ngIf="summaryAttributes[attributeIndex] === 'docId'">
              <!-- Doc Uploaded Icon -->
              <mat-icon *ngIf="element[monthIndex].document?.id"
                (click)="viewDocument(element[monthIndex].document.id)"
                class="hover-hand v-align-middle file green"
              >check_circle</mat-icon>
              <!-- /Doc Uploaded Icon -->

              <app-document-picker *ngIf="!bankAccount.aggregatorName"
                [borrowerId]="borrowerId"
                [(document)]="element[monthIndex].document"
                (documentChange)="onDocumentChange($event, monthIndex)"
                (documentError)="onDocumentError($event)">

                <!-- Doc Upload Action Icon -->
                <span app-document-picker-control-empty *ngIf="currentAcctView">
                  <mat-icon class="hover-hand v-align-middle blue">add_circle</mat-icon>
                </span>
                <!-- /Doc Upload Action Icon -->

                <span app-document-picker-control-loading>
                  <mat-spinner
                    diameter="20"
                    style="display: inline-block; height: 24px; width: 24px"
                    class="v-align-middle"
                  ></mat-spinner>
                </span>

                <!-- Doc Upload Action Selected Icon -->
                <span app-document-picker-control-selected>
                  <mat-icon class="hover-hand v-align-middle blue">add_circle</mat-icon>
                </span>
                <!-- /Doc Upload Action Selected Icon -->
              </app-document-picker>
              <span *ngIf="((bankAccount.aggregatorName && !element[monthIndex].document?.id) || !currentAcctView)">
                <mat-icon class="hover-hand v-align-middle red">cancel</mat-icon>
              </span>
            </span>
            <!-- /Document Cell -->

            <!-- Currency Cell -->
            <span *ngIf="currencyAttributes.includes(summaryAttributes[attributeIndex])">
              {{ (element[monthIndex]?.value | currency : currencyCode) ?? '-' }}
            </span>
            <!-- /Currency Cell -->

            <!-- Number Cell -->
            <span *ngIf="numberAttributes.includes(summaryAttributes[attributeIndex])">
              {{ element[monthIndex]?.value ?? '-' }}
            </span>
            <!-- /Number Cell -->
          </ng-container>
          <!-- /Cell View Only -->

          <!-- Cell Edit View -->
          <div class="summary-form v-align-middle"
            *ngIf="attributeIndex > 0 && monthIndex > 0 && (dataSource[0][monthIndex].value && editAccount)">
            <mat-form-field class="wp-70 input-field"
              *ngIf="currencyAttributes.includes(summaryAttributes[attributeIndex])">
              <input matInput type="text" mask="separator.2" thousandSeparator="," prefix="{{currencySymbol}}"
                [(ngModel)]="element[monthIndex].changeValue" [disabled]="retreiveMonthlySummaries">
            </mat-form-field>
            <mat-form-field class="wp-70 input-field"
              *ngIf="numberAttributes.includes(summaryAttributes[attributeIndex])">
              <input matInput type="text" mask="separator.0" thousandSeparator=","
                [(ngModel)]="element[monthIndex].changeValue" [disabled]="retreiveMonthlySummaries">
            </mat-form-field>
          </div>
          <!-- /Cell Edit View -->
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-container>


  <ng-template #FdTableView>
    <table mat-table [dataSource]="dataSource" class="mat-elevation-z8 fd-table" *ngIf="showTable">
      <ng-container [matColumnDef]="column.date" *ngFor="let column of displayedColumnObjects; let monthIndex=index;">

        <!-- Column Header -->
        <th mat-header-cell *matHeaderCellDef>
          <span *ngIf="monthIndex > 0 && !isAvgColumn(column)">
            <div class="month">{{ shortMonths[column.month] | uppercase }} {{ column.year }}</div>
          </span>
          <span *ngIf="monthIndex > 0 && isAvgColumn(column)">
            <div class="month">
              <i style="margin-right: 5px" class="lendio-alert__icon fa fa-lg fa-exclamation-triangle"
                *ngIf="formattedBankValues[0]?.numberMissingBankStatements3Month > 0 && column.date === 'avg3months'"
                matTooltip="This borrower is missing {{ formattedBankValues[0].numberMissingBankStatements3Month }} statement(s) within the last 3 months"
              ></i>
              <i style="margin-right: 5px" class="lendio-alert__icon fa fa-lg fa-exclamation-triangle"
                *ngIf="formattedBankValues[1]?.numberMissingBankStatements6Month > 0 && column.date === 'avg6months'"
                matTooltip="This borrower is missing {{ formattedBankValues[1].numberMissingBankStatements6Month }} statement(s) within the last 6 months"
              ></i>
              {{ column.month }} Months
            </div>
          </span>
        </th>
        <!-- /Column Header -->

        <!-- TD Cell -->
        <td [ngClass]="{'attribute': monthIndex === 0, 'value': monthIndex > 0, 'last-row': last}"
          mat-cell *matCellDef="let element; let attributeIndex=index; last as last">

          <!-- Row Header -->
          <span *ngIf="monthIndex === 0" (click)="saveSummaryChanges()">
            {{ fdSummaryDisplayAttributes[element[monthIndex].value] }}
          </span>
          <!-- /Row Header -->

          <!-- Cell View Only -->
          <ng-container *ngIf="isViewOnlyCell(monthIndex, attributeIndex)">

            <!-- Document Cell -->
            <span *ngIf="fdSummaryAttributes[attributeIndex] === 'docId'">
              <!-- Doc Uploaded Icon -->
              <mat-icon *ngIf="element[monthIndex].document?.id"
                (click)="viewDocument(element[monthIndex].document.id)"
                class="hover-hand v-align-middle file blue"
              >description</mat-icon>
              <!-- /Doc Uploaded Icon -->

              <app-document-picker *ngIf="!bankAccount.aggregatorName"
                [borrowerId]="borrowerId"
                [(document)]="element[monthIndex].document"
                (documentChange)="onDocumentChange($event, monthIndex)"
                (documentError)="onDocumentError($event)">

                <!-- Doc Upload Action Icon -->
                <span app-document-picker-control-empty *ngIf="currentAcctView">
                  <mat-icon *ngIf="!isAvgColumn(column)"
                    class="hover-hand v-align-middle green"
                  >add_circle</mat-icon>
                  <span *ngIf="isAvgColumn(column)"></span>
                </span>
                <!-- /Doc Upload Action Icon -->

                <span app-document-picker-control-loading>
                  <mat-spinner
                    diameter="20"
                    style="display: inline-block; height: 24px; width: 24px"
                    class="v-align-middle"
                  ></mat-spinner>
                </span>

                <!-- Doc Upload Action Selected Icon -->
                <span app-document-picker-control-selected>
                  <mat-icon class="hover-hand v-align-middle green">add_circle</mat-icon>
                </span>
                <!-- /Doc Upload Action Selected Icon -->
              </app-document-picker>
              <span *ngIf="((bankAccount.aggregatorName && !element[monthIndex].document?.id) || !currentAcctView)">
                <span *ngIf="!isAvgColumn(column)">-</span>
                <span *ngIf="isAvgColumn(column)"></span>
              </span>
            </span>
            <!-- /Document Cell -->

            <!-- Currency Cell -->
            <span *ngIf="currencyAttributes.includes(fdSummaryAttributes[attributeIndex])">
              {{ (element[monthIndex]?.value | currency : currencyCode) ?? '-' }}
            </span>
            <!-- /Currency Cell -->

            <!-- Number Cell -->
            <ng-container *ngIf="numberAttributes.includes(fdSummaryAttributes[attributeIndex])">
              <!-- {{ element[monthIndex]?.value ?? '-' }} -->
              <span *ngIf="!isAvgColumn(column)">
                {{ element[monthIndex]?.value ?? '-' }}
              </span>
              <span *ngIf="isAvgColumn(column)">
                {{ roundedAvg(element[monthIndex]?.value) ?? '-' }}
              </span>
              <span *ngIf="displayTotalTag(column, element, monthIndex, attributeIndex)"> Total</span>
            </ng-container>
            <!-- /Number Cell -->
          </ng-container>
          <!-- /Cell View Only -->

          <!-- Cell Edit View -->
          <div class="summary-form v-align-middle"
            *ngIf="attributeIndex > 0 && monthIndex > 0 && (dataSource[0][monthIndex].value && editAccount)">
            <mat-form-field class="wp-70 input-field"
              *ngIf="currencyAttributes.includes(fdSummaryAttributes[attributeIndex])">
              <input matInput type="text" mask="separator.2" thousandSeparator="," prefix="{{currencySymbol}}"
                [(ngModel)]="element[monthIndex].changeValue" [disabled]="retreiveMonthlySummaries">
            </mat-form-field>
            <mat-form-field class="wp-70 input-field"
              *ngIf="numberAttributes.includes(fdSummaryAttributes[attributeIndex])">
              <input matInput type="text" mask="separator.0" thousandSeparator=","
                [(ngModel)]="element[monthIndex].changeValue" [disabled]="retreiveMonthlySummaries">
            </mat-form-field>
          </div>
          <!-- /Cell Edit View -->
        </td>
      </ng-container>

      <!-- Main Table Header Groups -->
      <ng-container matColumnDef="monthly-to-month">
        <th mat-header-cell *matHeaderCellDef [style.text-align]="center" [attr.colspan]="7">
          Month to Month
        </th>
      </ng-container>

      <ng-container matColumnDef="monthly-totals">
        <th mat-header-cell *matHeaderCellDef [attr.colspan]="2"> Monthly Averages </th>
      </ng-container>
      <!-- /Main Table Header Groups -->

      <tr mat-header-row *matHeaderRowDef="['monthly-to-month', 'monthly-totals']" class="title-container"></tr>
      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
  </ng-template>

  <div class="aggregator-name-display">
    <span *ngIf="bankAccount.aggregatorName"> Uploaded via {{ bankAccount.aggregatorName}}</span>
    <span *ngIf="originalAccount">
      Originally uploaded via {{ originalAccount.aggregatorName}} -
      <a href="#" (click)="goToAccount($event)">
        <span *ngIf="currentAcctView; else returnCurent">View original entries</span>
        <ng-template #returnCurent>Return to current account</ng-template>
      </a>
    </span>
    <span *ngIf="!bankAccount.aggregatorName && !originalAccount">User created</span>
  </div>
</div>